export default {
    // 通用
    common: {
        confirm: '确定',
        cancel: '取消',
        save: '保存',
        delete: '删除',
        edit: '编辑',
        add: '添加',
        search: '搜索',
        reset: '重置',
        submit: '提交',
        back: '返回',
        loading: '加载中...',
        success: '操作成功',
        failed: '操作失败',
        tip: '提示',
        warning: '警告',
        error: '错误',
        close: '关闭',
        change: '更改',
        modify: '修改',
        bind: '绑定',
        unbind: '换绑',
        verify: '验证',
        query: '查询',
        exit: '退出',
        systemTip: '系统提示',
        contactAdmin: '请联系管理员',
        or: '或者使用以下方式'
    },
    // 登录相关
    login: {
        title: '用户登录',
        username: '用户名',
        password: '密码',
        login: '登录',
        register: '注册',
        forgetPassword: '忘记密码',
        rememberMe: '记住我',
        loginSuccess: '登录成功',
        loginFailed: '登录失败',
        loginExpired: '登录信息过期，请重新登录',
        phoneLogin: '短信登录',
        emailLogin: '邮箱登录',
        accountLogin: '账号登录',
        verifyCode: '验证码',
        getVerifyCode: '获取验证码',
        sendVerifyCode: '发送验证码',
        resendAfter: '秒后重新获取',
        resendAfterSend: '秒后重新发送',
        phone: '手机号',
        email: '邮箱',
        account: '账号',
        createAccount: '创建账号',
        enterPhoneOrAccount: '请输入手机号或账号或邮箱',
        enterPassword: '请输入密码',
        enterPhone: '请输入手机号',
        enterEmail: '请输入邮箱',
        enterVerifyCode: '请输入验证码',
        codeSentToPhone: '验证码已发送至您的手机！',
        codeSentToEmail: '验证码已发送至您的邮箱！',
        enterPhoneOrAccountHint: '请输入手机号或者账号',
        enterAccount: '请输入账号'
    },
    // 注册相关
    register: {
        title: '用户注册',
        confirmPassword: '确认密码',
        reenterPassword: '重新输入密码',
        registerSuccess: '注册成功',
        registerFailed: '注册失败',
        phoneRegister: '手机号注册',
        emailRegister: '邮箱注册',
        agreeAndRead: '我已同意并阅读',
        userAgreement: '用户协议、隐私政策',
        pleaseAgree: '请同意用户协议、隐私政策',
        passwordDifferent: '两次密码不同'
    },
    // 账户相关
    account: {
        title: '账号',
        accountManage: '账户管理',
        changePassword: '修改密码',
        oldPassword: '原密码',
        newPassword: '密码',
        confirmPassword: '确认密码',
        phone: '手机号',
        email: '邮箱',
        newPhone: '新手机号',
        newEmail: '新邮箱',
        enterUsername: '请输入用户名',
        enterOldPassword: '请输入原密码',
        enterPassword: '请输入密码',
        enterPasswordAgain: '请再次输入密码',
        enterPhone: '请输入手机号',
        enterNewPhone: '请输入新手机号',
        enterEmail: '请输入邮箱',
        enterNewEmail: '请输入新邮箱',
        enterVerifyCode: '请输验证码',
        passwordNotMatch: '两次输入密码不一致!',
        changeSuccess: '更改成功',
        modifySuccess: '修改成功',
        bindSuccess: '绑定成功',
        unbindSuccess: '换绑成功',
        deleteSuccess: '注销成功',
        disconnectSuccess: '取消绑定成功',
        codeSentCheckPhone: '验证码已发送，请检查手机号',
        codeSentCheckEmail: '验证码已发送，请检查邮箱',
        codeSentCheckBoundPhone: '验证码已发送，请检查该账号绑定的手机号',
        codeSentCheckBoundEmail: '验证码已发送，请检查该账号绑定的邮箱',
        exitLogin: '退出登录',
        deleteAccount: '账号注销',
        thirdPartyAccounts: '关联的第三方账户',
        platform: '平台',
        createDate: '创建日期',
        disconnect: '取消绑定',
        other: '其他',
        registerTime: '注册时间',
        loginPlatform: '登录平台',
        noPasswordWarning: '您的账号未设置密码，为了登录方便以及保证您的账号安全，请设置密码',
        noPhoneWarning: '您的账号未绑定手机号，为了登录方便以及保证您的账号安全，请绑定手机号',
        noEmailWarning: '您的账号未绑定邮箱，为了登录方便以及保证您的账号安全，请绑定邮箱',
        deleteConfirm:
            '是否确定要注销{account}账户？账户注销之后，会有15天的缓冲期，15天内，再次登录，会重新激活该账户。如果15天后，该账户未被重新激活，则账户会被自动删除！',
        disconnectConfirm: '确定要取消 {platform} 和您的账号的绑定状态? 取消后, 您将无法使用该平台进行快捷登录'
    },
    // 忘记密码
    forgetPwd: {
        title: '忘记密码',
        recoverAccount: '找回账号',
        enterRecoverAccount: '请输入找回账号',
        enterPhoneQuery: '请输入手机号查询',
        enterEmailQuery: '请输入邮箱查询',
        forgetAccount: '忘记账号',
        forgetPhone: '忘记手机号',
        forgetEmail: '忘记邮箱',
        noUsernameSet: '该账号未设置用户名，请登录成功之后进行设置！',
        noPhoneOrEmail: '该账号未绑定手机或邮箱，请联系管理员找回！',
        passwordDifferent: '两次密码不同',
        enterNewPassword: '请输入密码',
        reenterPassword: '重新输入密码',
        codeSentTo: '验证码已发送至！{contact}',
        modifySuccessLogin: '修改成功 正在进行登录'
    },
    // 菜单
    menu: {
        home: '首页',
        account: '账户管理',
        logout: '退出登录'
    },
    // 验证消息
    validation: {
        required: '此项为必填项',
        emailFormat: '请输入正确的邮箱格式',
        phoneFormat: '请输入正确的手机号格式',
        passwordLength: '密码长度应为6-20个字符',
        passwordNotMatch: '两次输入的密码不一致'
    },
    header: {
        customerAccount: '联系客服',
        region: '服务器',
        china: '中国',
        overseas: '海外',
        confirmSwitchRegion: '切换服务器后需要重新登录，是否确认切换到「{region}」服务器?'
    },
    // 页脚
    footer: {
        copyright: 'Copyright © 2023 COTTON GAME. 保留所有权利',
        healthAdvice: '健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当',
        moderateGaming: '适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活'
    },
    // 网络请求
    request: {
        networkError: '网络错误',
        timeout: '请求超时',
        authExpired: '身份验证已过期，请重新登录！',
        docSuccess: '文档请求成功'
    },
    // 路由标题
    router: {
        home: '首页',
        account: '账户管理',
        login: '登录',
        phoneLogin: '手机号登录',
        emailLogin: '邮箱登录',
        forgetPwd: '忘记密码',
        phoneRegister: '手机号注册',
        emailRegister: '邮箱注册'
    },
    // 首页
    home: {
        personalInfo: '个人信息',
        giftCodeRedeem: '礼包码兑换'
    },
    // 礼包码
    giftCode: {
        title: '礼包码兑换',
        selectProject: '选择游戏',
        selectProjectPlaceholder: '请选择游戏',
        selectProjectRequired: '请选择游戏',
        code: '礼包码',
        enterCode: '请输入礼包码',
        enterCodeRequired: '请输入礼包码',
        redeem: '兑换',
        redeemSuccessTitle: '兑换成功',
        redeemSuccessTip: '兑换成功！请关闭游戏并重新进入，奖励将自动发放到您的账户中。'
    }
};
